import * as pdfjsLib from 'pdfjs-dist';

// Worker served from public/ (CRA copies it as-is to build root)
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

/**
 * Convert a PDF file to an array of page images.
 *
 * @param {File} file - PDF file from an <input type="file">
 * @returns {Promise<Array<{ src: string, width: number, height: number, pageNum: number }>>}
 */
export async function pdfToImages(file) {
  const arrayBuffer = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
  const pages = [];
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const viewport = page.getViewport({ scale: 2 });
    const canvas = document.createElement("canvas");
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    const ctx = canvas.getContext("2d");
    await page.render({ canvasContext: ctx, viewport }).promise;
    pages.push({
      src: canvas.toDataURL("image/png"),
      width: viewport.width,
      height: viewport.height,
      pageNum: i,
    });
  }
  return pages;
}
